import React from "react";

export default function TrendingDownIcon({ className = "" }) {
  return (
    <svg 
      width="14" 
      height="9" 
      viewBox="0 0 14 9" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M9.66683 8.5V7.16667H11.4002L7.9335 3.73333L5.26683 6.4L0.333496 1.43333L1.26683 0.5L5.26683 4.5L7.9335 1.83333L12.3335 6.23333V4.5H13.6668V8.5H9.66683Z" fill="currentColor"/>
    </svg>
  );
} 